import authLocalData from "../services/data/authLocalDataService";
import authLocalDataService from "./../services/data/authLocalDataService";
import jwt_decode from "jwt-decode";
import safeLocalStorageService from "./../services/useSafeLocalStorage";
import { Context as LanguageContext } from "../Context/LanguageContext";

export default class Auth {
  constructor(history, pathname) {
    this.history = history;
    this.userProfile = null;
    this.pathname = pathname;
    // this.auth0 = new auth0.WebAuth({
    //   domain: process.env.REACT_APP_AUTH_DOMAIN,
    //   clientID: process.env.REACT_APP_AUTH_CLIENT_ID,
    //   redirectUri: process.env.REACT_APP_CALLBACK_URL,
    //   //redirectUri: "http://localhost:3000/callback",
    //   responseType: process.env.REACT_APP_AUTH_RESPONSE_TYPE,
    //   overrides: {
    //     __token_issuer: process.env.REACT_APP_AUTH_TOKEN_ISSUER
    //   },
    //   scope: "openid profile email write:user",
    //   responseMode: "form_post"
    // });
  }

  static contextType = LanguageContext;

  login = (lang) => {
    try {
      localStorage.setItem("base_Url", window.location.href);
      localStorage.setItem("loggedIn", false);
    } catch (err) {
      console.log(err.message);
    }

    var localStorageCallbackURL =
      safeLocalStorageService.getItem("callbackURL");
    let domainCallbackURL =
      window.location.origin + "/" + process.env.REACT_APP_CALLBACK_PATH;

    if (
      localStorageCallbackURL !== null &&
      localStorageCallbackURL !== undefined &&
      localStorageCallbackURL !== "undefined" &&
      localStorageCallbackURL !== ""
    ) {
      domainCallbackURL = localStorageCallbackURL;
    }

    const langToUse = lang ? lang : "en";

    var redirectUrl =
      process.env.REACT_APP_AUTH_DOMAIN +
      process.env.REACT_APP_AUTH_CLIENT_ID +
      "&response_type=" +
      process.env.REACT_APP_AUTH_RESPONSE_TYPE +
      "&redirect_uri=" +
      domainCallbackURL +
      "&lang=" +
      langToUse;
    window.location.href = redirectUrl;
  };

  handleAuthentication = (auth) => {
    // this.auth0.parseHash( ( err, hash ) => {
    //   if ( hash && hash.accessToken && hash.idToken ) {
    //     // Success.
    //     this._handleAuthenticationSuccess( hash );
    //     window.location.href = this.pathname === "/callback" ? localStorage.getItem("base_Url") : this.pathname;
    //   } else if (err) {
    //     // Failure.
    //     this.history.push("/");
    //     alert(`Error: ${err.error}. Check the console for further details.`);
    //     console.log(err);
    //   }
    // });

    try {
      const authObject = this.parseAuthHash(auth);
      this._handleAuthenticationSuccess(authObject);

      // Get the base URL that was stored before redirecting to login
      const baseUrl = localStorage.getItem("base_Url");

      // Determine where to redirect after successful authentication
      let redirectUrl = window.location.origin; // Default fallback

      if (baseUrl && baseUrl !== "undefined" && baseUrl !== "null" && baseUrl !== "") {
        // Use the stored base URL if it's valid
        redirectUrl = baseUrl;
      } else if (this.pathname && this.pathname !== "/callback" && this.pathname !== "undefined") {
        // If we have a valid pathname that's not callback, use it
        redirectUrl = window.location.origin + this.pathname;
      }

      window.location.href = redirectUrl;
    } catch (error) {
      this.history.push("/");
      alert(`Error: ${error.error}. Check the console for further details.`);
      console.log(error);
    }
  };

  parseAuthHash = (auth) => {
    const tempAuthString = auth.location.hash.substring(1);
    let tempAuthArray = tempAuthString.split("&");
    var authResult = {};
    tempAuthArray.forEach(function (tempAuthArray) {
      var newValue = tempAuthArray.split("=");
      authResult[newValue[0]] = newValue[1];
    });
    return authResult;
  };

  _handleAuthenticationSuccess = (authResult) => {
    const idToken = authResult.id_token;
    const accessToken = authResult.access_token;
    const expiresAt =
      parseInt(authResult.expires_in) * 1000 + new Date().getTime();
    var decoded = jwt_decode(authResult.id_token);
    const userData = decoded;

    // cookieService.setAuthCookies(idToken, accessToken);

    authLocalData.setAuth({
      accessToken,
      idToken,
      expiresAt,
    });
    authLocalData.setAPIMUser({
      identityEmail: userData.email,
      firstName: userData.given_name,
      lastName: userData.family_name,
    });
  };

  isAuthenticated() {
    return !!authLocalData.getIdToken();
  }
  //TO DO: Cookies set here should be non-persistent. Currently this is a vulnerability on closing the application sessions are not cleared.
  logout = () => {
    authLocalData.clear();

    this.userProfile = null;

    var localStorageLogoutURL =
      safeLocalStorageService.getItem("logoutRedirectURL");
    let logoutRedirectURL =
      window.location.origin +
      "/" +
      process.env.REACT_APP_LOG_OUT_REDIRECT_PATH;

    if (
      localStorageLogoutURL !== null &&
      localStorageLogoutURL !== undefined &&
      localStorageLogoutURL !== "undefined" &&
      localStorageLogoutURL !== ""
    ) {
      logoutRedirectURL = localStorageLogoutURL;
    }

    window.location.href =
      process.env.REACT_APP_LOG_OUT_URL + logoutRedirectURL;
  };

  getAccessToken = () => {
    const accessToken = authLocalData.getAccessToken();
    if (!accessToken) {
      throw new Error("No access token found.");
    }
    return accessToken;
  };

  getProfile = (cb) => {
    if (this.userProfile) return cb(this.userProfile);
    this.auth0.client.userInfo(this.getAccessToken(), (err, profile) => {
      if (profile) this.userProfile = profile;
      cb(profile, err);
    });
  };
}
